import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserDetectionServices {
  _userAgent = window.navigator.userAgent;

  // IS EDGE
  _isEdge = this._userAgent.toLowerCase().indexOf('edge') > -1;
  // IS FIREFOX
  _isFirefox = this._userAgent.toLowerCase().indexOf('firefox') > -1;
  // IS CHROME
  _isChrome = this._userAgent.toLowerCase().indexOf('chrome') > -1;
  // IS SAFARI
  _isSafari = this._userAgent.toLowerCase().indexOf('safari') > -1;
  // IS OPERA
  _isOpera = this._userAgent.toLowerCase().indexOf('opr') > -1;

  constructor() {}

  checkBrowserType(browserName) {
    const key = browserName.toLowerCase();
    switch (key) {
      case 'edge': {
        return this._isEdge;
      }
      case 'firefox': {
        return this._isFirefox;
      }
      case 'chrome': {
        return this._isChrome;
      }
      case 'safari': {
        return this._isSafari;
      }
      case 'opera': {
        return this._isOpera;
      }
    }
  }
}
